module.exports = __webpack_public_path__ + "static/media/play-boss-lose-1.8342de45.png";